import React, { useEffect, useState } from "react";

// JS Files

// Others File
import phoneIcon from "../../imgs/1401.svg";

import iranIcon from "../../imgs/iran.svg";
import evaluateIcon from "../../imgs/evaluate.svg";
import consultIcon from "../../imgs/consult.svg";


const Introduction = () => {
  return (
    <>
      {/* Desktop */}
      <div className="hidden md:flex md:justify-between md:items-center  md:mx-16 md:mb-2">
        <div className="basis-1/2">
          <div className="flex flex-col items-center">
            <span className="text-5xl" style={{ fontFamily: "lale" }}>
              رفاپ
            </span>
            <span className="text-4xl mt-4" style={{ fontFamily: "lale" }}>
              رفاه فرهنگیان آموزش و پرورش
            </span>
            <span
              className="text-2xl mt-8 text-mygray-500"
              style={{ fontFamily: "lale" }}
            >
              خدمات رایگان آنلاین ویژه معلمان و دانش‌آموزان
            </span>
            <span
              className="text-2xl mt-2 text-mygray-500"
              style={{ fontFamily: "lale" }}
            >
              ثبت و پیگیری اعتراضات و مشاوره خسارت بیمه‌ای
            </span>
          </div>
          <div className="mt-16  rounded-lg bg-myblue-500 p-4 grid grid-cols-3 gap-x-4 ">
            <div className="border-l-4 border-white flex flex-col justify-center items-center">
              <img src={iranIcon} />
              <span className="mt-2">پوشش کشوری</span>
            </div>
            <div className="border-l-4 border-white flex flex-col justify-center items-center">
              <img src={evaluateIcon} />
              <span className="mt-2">بازرسی و نظارت</span>
            </div>
            <div className="flex flex-col justify-center items-center">
              <img src={consultIcon} />
              <span className="mt-2">مشاوره الکترونیکی</span>
            </div>
          </div>
        </div>
        <a href="tel:1401">
          <div className="basis-1/2">
            <img src={phoneIcon} />
          </div>
        </a>
      </div>
      {/* Mobile */}
      <div className="mx-4 md:hidden">
        <div className="flex flex-col items-center justify-center text-center">
          <span className="text-3xl" style={{ fontFamily: "lale" }}>
            رفاپ
          </span>
          <span className="text-2xl mt-4" style={{ fontFamily: "lale" }}>
            رفاه فرهنگیان آموزش و پرورش
          </span>
          <span
            className="text-xl mt-8 text-mygray-500"
            style={{ fontFamily: "lale" }}
          >
            خدمات رایگان آنلاین ویژه معلمان و دانش‌آموزان
          </span>
          <span
            className="text-xl mt-2 text-mygray-500"
            style={{ fontFamily: "lale" }}
          >
            ثبت و پیگیری اعتراضات و مشاوره خسارت بیمه‌ای
          </span>
          <a href="tel:1401">
            <img src={phoneIcon} />
          </a>
          <div className="mt-4 w-full">
            <div className="mt-4 rounded-lg bg-myblue-500 p-4 flex items-center ">
              <img src={iranIcon} />
              <span className="mr-8">پوشش کشوری</span>
            </div>
            <div className="mt-4 rounded-lg bg-myblue-500 p-4 flex items-center ">
              <img src={evaluateIcon} />
              <span className="mr-8">بازرسی و نظارت</span>
            </div>
            <div className="mt-4 rounded-lg bg-myblue-500 p-4 flex items-center">
              <img src={consultIcon} />
              <span className="mr-8">مشاوره الکترونیکی</span>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default Introduction;
